import React, {useEffect} from 'react';
import Message from './Message';
import {doc, updateDoc} from 'firebase/firestore';
import {db} from "../firebase/firebase";

const ChatMessages = ({ messages, chatId }) => {
  useEffect(() => {
    const last = messages && messages[messages.length - 1];
    if (!chatId || !last) return;
    if (last.sender === 'client' && !last.readed) {
      (async () => {
        try {
          await updateDoc(doc(db, 'chats', chatId), {
            'lastMessage.readed': true
          });
        } catch (error) {
          console.error('Failed to mark as read:', error);
        }
      })();
    }
  }, [chatId, messages]);

  return (
    <div className='chat-messages'>
      {messages?.map((message) => (
        <Message key={message.id} message={message} />
      ))}
    </div>
  );
};

export default ChatMessages;
